/* Product minima are enforced at add, cart edit and storefront checkout. */
(() => {
  'use strict';
  const tr = document.documentElement.lang.startsWith('tr');
  const quantitySelector = 'input[name="quantity"], input[name="updates[]"]';
  const checkoutSelector = '[name="checkout"],a[href$="/checkout"],a[href*="/checkout?"]';
  const root = () => window.Shopify?.routes?.root || '/';
  const validQuantity = (value, minimum, increment = 1) =>
    Number.isInteger(Number(value)) && Number(value) >= minimum &&
    (Number(value) - minimum) % increment === 0;

  function showError(message) {
    let box = document.getElementById('mb-minimum-error');
    if (!box) {
      box = document.createElement('div');
      box.id = 'mb-minimum-error';
      box.setAttribute('role', 'alert');
      box.style.cssText = 'position:fixed;top:16px;left:50%;transform:translateX(-50%);z-index:2147483647;max-width:90vw;width:540px;padding:16px 20px;background:#fff4f4;color:#8b1010;border:2px solid #b71c1c;border-radius:10px;box-shadow:0 4px 20px #0003;white-space:pre-line';
      document.body.append(box);
    }
    box.textContent = message;
    box.hidden = false;
  }
  function validateInput(input, value = input?.value) {
    if (!input) return true;
    const minimum = Math.max(1, Number(input.min) || 1);
    const step = Math.max(1, Number(input.step) || 1);
    const maximum = input.max ? Number(input.max) : Infinity;
    const valid = validQuantity(value, minimum, step) && Number(value) <= maximum;
    input.setCustomValidity('');
    if (!valid) {
      const message = tr
        ? `Minimum sipariş miktarı ${minimum}. Lütfen geçerli bir miktar girin.`
        : `Minimum order quantity is ${minimum}. Please enter a valid quantity.`;
      input.setCustomValidity(message);
      input.reportValidity();
      showError(message);
    }
    return valid;
  }
  function validateForm(form) {
    const input = Array.from(form.elements).find(el => el.name === 'quantity');
    return validateInput(input);
  }
  async function validateCart() {
    try {
      for (const input of document.querySelectorAll('input[name="updates[]"]')) {
        if (input.getClientRects().length && !validateInput(input)) return false;
      }
      // Allow the cart's debounced change handler to start, then wait for its request.
      await new Promise(resolve => setTimeout(resolve, 350));
      await window.mbCartUpdatePromise;
      const response = await fetch(`${root()}cart?section_id=mb-cart-minimums&_=${Date.now()}`, { cache: 'no-store' });
      if (!response.ok) throw new Error('Cart validation unavailable');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = html.querySelector('[data-mb-cart-minimums]');
      if (!data) throw new Error('Missing cart rules');
      const items = JSON.parse(data.textContent);
      const invalid = items.filter(item => !validQuantity(item.quantity, item.minimum, item.increment));
      if (!invalid.length && items.length) return true;
      const message = invalid.length
        ? (tr ? 'Devam etmek için sepet miktarlarını düzeltin:\n' : 'Please correct these cart quantities before checkout:\n') +
          invalid.map(item => `${item.title}: ${item.quantity} → ${tr ? 'en az' : 'minimum'} ${item.minimum}`).join('\n')
        : (tr ? 'Sepetiniz boş.' : 'Your cart is empty.');
      showError(message);
      return false;
    } catch (_) {
      showError(tr ? 'Sepet kontrol edilemedi. Lütfen tekrar deneyin.' : 'Unable to verify your cart. Please try again.');
      return false;
    }
  }
  window.MBMinimumOrders = { validateInput, validateForm, validateCart, validQuantity };

  function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  function isAdd(form) { return form instanceof HTMLFormElement && /\/cart\/add(?:\.js)?$/.test(new URL(form.action, location.href).pathname); }
  let checkingOut = false;
  async function guardCheckout(event, control) {
    stop(event);
    if (checkingOut) return;
    checkingOut = true;
    try {
      if (await validateCart()) {
        // Let the existing ZIP/box gate handle checkout only after this fresh check.
        control.dataset.mbMinimumReady = 'true';
        control.click();
        delete control.dataset.mbMinimumReady;
      }
    } finally { checkingOut = false; }
  }
  window.addEventListener('click', event => {
    const control = event.target.closest('button,input[type="submit"],a');
    if (!control) return;
    if (isAdd(control.form) && control.type === 'submit' && !validateForm(control.form)) return stop(event);
    if (control.matches(checkoutSelector) && control.dataset.mbMinimumReady !== 'true') guardCheckout(event, control);
  }, true);
  window.addEventListener('submit', event => {
    if (isAdd(event.target) && !validateForm(event.target)) return stop(event);
    if (/\/cart$/.test(new URL(event.target.action, location.href).pathname)) {
      const control = event.submitter || event.target.querySelector(checkoutSelector) || document.querySelector(checkoutSelector);
      if (control && control.dataset.mbMinimumReady !== 'true') guardCheckout(event, control);
    }
  }, true);
  window.addEventListener('input', event => {
    if (event.target.matches(quantitySelector)) {
      event.target.setCustomValidity('');
      const box = document.getElementById('mb-minimum-error');
      if (box) box.hidden = true;
    }
  }, true);
  window.addEventListener('change', event => {
    if (event.target.matches(quantitySelector) && !validateInput(event.target)) {
      if (event.target.name === 'updates[]') {
        event.target.value = event.target.getAttribute('value') || event.target.min;
      }
      stop(event);
    }
  }, true);
})();
